import * as THREE from 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js';

const container = document.getElementById('three-stage');

// ===== サイズ =====
let width = container.clientWidth;
let height = container.clientHeight;

// ===== シーン =====
const scene = new THREE.Scene();

// ===== カメラ =====
const camera = new THREE.PerspectiveCamera(60, width / height, 0.1, 100);
camera.position.z = 10;

// ===== レンダラー =====
const renderer = new THREE.WebGLRenderer({ alpha: true });
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
renderer.setSize(width, height);
container.appendChild(renderer.domElement);

// ===== 設定 =====
const POINT_COUNT = 70;
const RANGE = 20;
const SPEED = 0.008;
const CONNECT_DISTANCE = 2.0;

// ===== データ保持 =====
const positions = new Float32Array(POINT_COUNT * 3);
const velocities = new Float32Array(POINT_COUNT * 3);

// 初期化
for (let i = 0; i < POINT_COUNT; i++) {
  const i3 = i * 3;

  positions[i3]     = (Math.random() - 0.5) * RANGE;
  positions[i3 + 1] = (Math.random() - 0.5) * RANGE;
  positions[i3 + 2] = (Math.random() - 0.5) * RANGE;

  velocities[i3]     = (Math.random() - 0.5) * SPEED;
  velocities[i3 + 1] = (Math.random() - 0.5) * SPEED;
  velocities[i3 + 2] = (Math.random() - 0.5) * SPEED;
}

// ===== ポイント =====
const pointsGeometry = new THREE.BufferGeometry();
pointsGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

const pointsMaterial = new THREE.ShaderMaterial({
  transparent: true,
  uniforms: {
    color: { value: new THREE.Color(0x515151) }
  },
  vertexShader: `
    void main() {
      gl_PointSize = 3.0;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform vec3 color;

    void main() {
      vec2 uv = gl_PointCoord - vec2(0.5);
      float d = length(uv);

      if (d > 0.5) discard;

      gl_FragColor = vec4(color, 1.0);
    }
  `
});

const points = new THREE.Points(pointsGeometry, pointsMaterial);
scene.add(points);

// ===== 線（最大サイズ確保して使い回す）=====
const maxLines = POINT_COUNT * POINT_COUNT;
const linePositions = new Float32Array(maxLines * 3);

const lineGeometry = new THREE.BufferGeometry();
lineGeometry.setAttribute('position', new THREE.BufferAttribute(linePositions, 3));

const lineMaterial = new THREE.LineBasicMaterial({
  color: 0x272727,
  transparent: true,
  opacity: 0.2
});

const lines = new THREE.LineSegments(lineGeometry, lineMaterial);
scene.add(lines);

// ===== アニメーション =====
function animate() {
  requestAnimationFrame(animate);

  // ノード移動
  for (let i = 0; i < POINT_COUNT; i++) {
    const i3 = i * 3;

    positions[i3]     += velocities[i3];
    positions[i3 + 1] += velocities[i3 + 1];
    positions[i3 + 2] += velocities[i3 + 2];

    // 範囲内でバウンス
    for (let j = 0; j < 3; j++) {
      if (positions[i3 + j] > RANGE / 2 || positions[i3 + j] < -RANGE / 2) {
        velocities[i3 + j] *= -1;
      }
    }
  }

  // 線の再計算
  // ===== 線の再計算（改良版）=====
  let ptr = 0;

  // ① 必ず全点を繋ぐ（最低限の骨格）
  for (let i = 0; i < POINT_COUNT - 1; i++) {
    const i3 = i * 3;
    const j3 = (i + 1) * 3;

    linePositions[ptr++] = positions[i3];
    linePositions[ptr++] = positions[i3 + 1];
    linePositions[ptr++] = positions[i3 + 2];

    linePositions[ptr++] = positions[j3];
    linePositions[ptr++] = positions[j3 + 1];
    linePositions[ptr++] = positions[j3 + 2];
  }

  // ② 近い点同士を追加接続（密度アップ）
  for (let i = 0; i < POINT_COUNT; i++) {
    for (let j = i + 2; j < POINT_COUNT; j++) {
      const i3 = i * 3;
      const j3 = j * 3;

      const dx = positions[i3] - positions[j3];
      const dy = positions[i3 + 1] - positions[j3 + 1];
      const dz = positions[i3 + 2] - positions[j3 + 2];

      const dist = dx * dx + dy * dy + dz * dz;

      if (dist < CONNECT_DISTANCE * CONNECT_DISTANCE) {
        linePositions[ptr++] = positions[i3];
        linePositions[ptr++] = positions[i3 + 1];
        linePositions[ptr++] = positions[i3 + 2];

        linePositions[ptr++] = positions[j3];
        linePositions[ptr++] = positions[j3 + 1];
        linePositions[ptr++] = positions[j3 + 2];
      }
    }
  }

  lineGeometry.setDrawRange(0, ptr / 3);
  lineGeometry.attributes.position.needsUpdate = true;

  pointsGeometry.attributes.position.needsUpdate = true;

  renderer.render(scene, camera);
}

animate();

// ===== リサイズ =====
window.addEventListener('resize', () => {
  width = container.clientWidth;
  height = container.clientHeight;

  renderer.setSize(width, height);
  camera.aspect = width / height;
  camera.updateProjectionMatrix();
});